"use strict";
// saveMoneyPageTypingText
(function ($) {
    'use strict';
    var typeText = $(".js-saveMoneyTypingText"), panel = typeText.parents('.content');
    function saveMoneyPageTypingText() {
        typeText.typed({
            strings: ["buying lunch", "buying train tickets", "paying a utility bill", "buying groceries"],
            startDelay: 1000,
            typeSpeed: 20
        });
    }
    if (panel.length) {
        panel.on('toggled', function (event, tab) {
            saveMoneyPageTypingText();
        });
    }
})(jQuery);
